import { QueryResult } from '@apollo/client';

import { ConversationIcon } from '@treams/treams-icons';
import { EvaluationSubmission, EvaluationSubmissionsQuery } from '@treams/treams-network';
import { CardList } from '@treams/treams-ui';

import ConversationCard from './ConversationCard';

export default function IncomingConversationsList(props: {
	query: QueryResult<EvaluationSubmissionsQuery>;
	archivedQuery: QueryResult<EvaluationSubmissionsQuery>;
	fetchArchived: () => void;
}) {
	return (
		<CardList
			translationName="conversations.incoming"
			query={props.query}
			archivedQuery={props.archivedQuery}
			fetchArchived={props.fetchArchived}
			path="user.evaluationSubmissions"
			skeletonRepeat={2}
			icon={<ConversationIcon />}
			renderCard={(item: EvaluationSubmission) => (
				<ConversationCard key={item.id} submission={item} />
			)}
			renderSkeleton={() => <ConversationCard.Skeleton />}
		/>
	);
}
